import { RouteSheet } from '@/components/route-sheet';
import { useGetMatchedRoute } from '@/hooks/routing';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(security)/security/_sheet')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const match = useGetMatchedRoute();
  let hasBack = false;
  let backAsRouterNavigateBack = false;
  let title = '';
  let subtitle: string | undefined;
  const { t } = useI18n();
  switch (match.routeId) {
    case '/(security)/security/_sheet/two-factor-code/': {
      hasBack = true;
      title = t('TwoFactorCodeInput.Title');
      const loaderData = match.loaderData as { target?: string } | undefined;
      subtitle = t('TwoFactorCodeInput.Subtitle', { contact: loaderData?.target });
      break;
    }
    case '/(security)/security/_sheet/account-activity/':
      title = t('AccountActivity.List.Title');
      break;
    case '/(security)/security/_sheet/active-sessions/':
      hasBack = false;
      backAsRouterNavigateBack = false;
      title = '';
      break;
    case '/(security)/security/_sheet/account-activity/filters/':
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t('AccountActivity.Filters.Title');
      break;
  }

  return (
    <RouteSheet
      onClose={() => navigate({ to: '/security' })}
      options={{ hasBack, backAsRouterNavigateBack, title, subtitle }}
    />
  );
}
